import PropTypes from "prop-types"
import { BASE } from "../../shapes"
import "./style.scss"

function Base({ row: { key }, children }) {
  return <tr className="row base">
    <th className="base-id">{key}</th>
    {children}
  </tr>
}

Base.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  row: BASE.isRequired,
}

export default Base
